// frontend/src/config.js
const getApiBase = () => {
  // Priorité 1 : Variable d'environnement REACT_APP_API_URL (pour Vercel)
  // Vérifier explicitement si la variable existe et n'est pas vide
  const envApiUrl = process.env.REACT_APP_API_URL;
  if (envApiUrl && envApiUrl.trim() !== '' && envApiUrl !== 'https://www.workbiflow.com') {
    console.log('✅ Utilisation de REACT_APP_API_URL:', envApiUrl);
    return envApiUrl;
  }
  
  // Priorité 2 : En production, utiliser l'URL Render directement
  if (process.env.NODE_ENV === 'production') {
    console.log('✅ Production: utilisation de Render backend');
    return 'https://workbiflow-backend-1.onrender.com';
  }
  
  // En développement, utiliser localhost
  console.log('✅ Développement: utilisation de localhost');
  return 'http://localhost:3001';
};

export const API_BASE = getApiBase();

/** Fetch CSRF token for state-changing API calls (leave, billing, etc.). Returns '' on failure. */
export const getCsrfToken = async () => {
  try {
    const res = await fetch(`${getApiBase()}/api/auth/csrf-token`, { method: 'GET' });
    if (res.ok) {
      const data = await res.json();
      return data.csrfToken || '';
    }
  } catch (e) {}
  return '';
};

// Super Admin: email used to show Super Admin panel after login (must match backend SUPER_ADMIN_EMAIL_ADDRESS)
export const SUPER_ADMIN_EMAIL = (process.env.REACT_APP_SUPER_ADMIN_EMAIL || 'contact@peak-performance-partner.com').trim().toLowerCase();

// Debug log pour vérifier
console.log('🔍 API_BASE configuré:', API_BASE);
console.log('🔍 NODE_ENV:', process.env.NODE_ENV);
console.log('🔍 REACT_APP_API_URL (raw):', process.env.REACT_APP_API_URL);
// console.log('🔍 URL finale sera:', `${API_BASE}/api/employees`); // Supprimé car plus utilisé dans Planning
console.log('✅ Version: 2025-12-06 - Utilise API_BASE depuis config.js');
